import { RouteHttpVerb } from "@devowl-wp/utils";
const locationRestJobGet = {
    path: "/job/:id",
    method: RouteHttpVerb.GET
};
export { locationRestJobGet };
